import { CustomerPatchRequestBody, CustomerPatchResponse, CustomerRequestParams } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUpdateCustomer = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const mutationFn = ({ customerId, ...body }: CustomerPatchRequestBody & CustomerRequestParams) =>
    client.patch(`customer/${customerId}`, { json: body }).json<CustomerPatchResponse>();

  const result = useMutation({
    mutationFn,
    onSuccess: (_, variables) => {
      // Invalidate the specific customer query
      queryClient.invalidateQueries({
        queryKey: customerQueryKey.getCustomer(variables.customerId),
      });
      // Also invalidate customer list queries so list views get fresh data
      queryClient.invalidateQueries({
        queryKey: [...customerQueryKey._customer, 'list'],
      });
    },
  });

  return { ...result, updateCustomer: result.mutateAsync };
};
